import {
  Directive,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ArrayUtils } from '../utils/array-utils';

@Directive({
  selector: '[elxSortSelectOptions]',
  standalone: true,
})
export class SortSelectOptionsDirective implements OnChanges {
  @Input() elxSortSelectOptions: unknown[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    const arr = changes['elxSortSelectOptions'];
    if (arr?.currentValue && Array.isArray(arr.currentValue)) {
      const sorted = ArrayUtils.sortDropdownValues(
        [...arr.currentValue],
        'No Data Found'
      );
      arr.currentValue.length = 0;
      arr.currentValue.push(...sorted);
    }
  }
}
